import { render, staticRenderFns } from "./BitrixChannels.vue?vue&type=template&id=2ec0b9de&scoped=true"
import script from "./BitrixChannels.vue?vue&type=script&lang=js"
export * from "./BitrixChannels.vue?vue&type=script&lang=js"
import style0 from "./BitrixChannels.vue?vue&type=style&index=0&id=2ec0b9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0b9de",
  null
  
)

export default component.exports